import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import IconHome from "../SvgIcons/IconHome";
import IconCreateAgents from "../SvgIcons/IconCreateAgents";
import IconManageAgents from "../SvgIcons/IconManageAgents";
import IconCustomers from "../SvgIcons/IconCustomers";
import IconReports from "../SvgIcons/IconReports";
import IconPlus from "../SvgIcons/IconPlus";
import IconTickets from "../SvgIcons/IconTickets";
import IconTicketsActive from "../SvgIcons/IconTicketsActive";
import { useAuth } from "../../context/AuthContext";
import api from "../../services/axios";
import "./style.css";
import IconMenu from "../SvgIcons/IconMenu";
import IconTemplates from "../SvgIcons/IconTemplates";
import IconAirplaneTakeoffMenu from "../SvgIcons/IconAirplaneTakeoffMenu";
import utils from "../../utils/utils";

export default function SideBarMenu() {
  const { authUser } = useAuth();
  const [summary, setSummary] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const loadSummary = async () => {
      try {
        const response = await api.post("/Dashboard_Summary", {});
        setSummary(response.data);
      } catch (error) {
        console.error("Failed to load dashboard summary", error);
      }
    };

    loadSummary();
  }, []);

  // const isAdmin = authUser?.isAdmin;
  const location = useLocation();
  const { pathname } = useLocation();
  const sidebarRef = useRef(null);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  const toggleMenu = () => {
    document.body.classList.toggle("menu-open");
  };

  useEffect(() => {
    console.log(authUser);
  }, [authUser])

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("agent");
    localStorage.removeItem("tokenExpiry");
    navigate("/");
  };

  // Detect outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        document.body.classList.contains("menu-open") &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        document.body.classList.remove("menu-open");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const saveRecentSearch = (e) => {
    const linkEl = e.target.closest("a");
    if (!linkEl) return;

    const href = linkEl.getAttribute("href");
    const linkText = linkEl.textContent.trim(); // cleaner text
    utils.saveRecentSearch(linkText, href);
  };

  return (
    <div className="manu-main">
      {/* ref={sidebarRef} */}
      <Link
        to="#"
        className="tranparenteffect menuopen position-relative"
        onClick={toggleMenu}
      >
        <IconMenu />
        {/* <IconOpenMenu /> */}
      </Link>
      <nav className="sidebar-main">
        <div className="topmenu">
          {authUser?.Agents_Company?.trim() === "Global Assist" && (
            <Link to="/create-ticket" className="btn btngradiant supportticket">
              <IconPlus /> <span>Add New Support Ticket</span>
            </Link>
          )}
          <ul>
            <li>
              <Link
                to="/dashboard"
                className={location.pathname === "/dashboard" ? "active" : ""}
              >
                <IconHome /> <span>Dashboard</span>
              </Link>
            </li>
            {(authUser?.isAdmin && authUser?.Agents_Company == 'Global Assist') && (
              <li>
                <label className="nav-title">Users</label>
                <Link
                  to="/create-agents"
                  className={
                    [
                      "/create-agents",
                      "/edit-agents-details",
                      "/view-agents-details",
                    ].some((path) => location.pathname.startsWith(path))
                      ? "active"
                      : ""
                  }
                >
                  <IconCreateAgents /> <span>Create Agents</span>
                </Link>
                <Link
                  to="/manage-agents"
                  className={
                    location.pathname === "/manage-agents" ? "active" : ""
                  }
                >
                  <IconManageAgents /> <span>Manage Agents</span>
                </Link>
              </li>
            )}
            <li>
              <label className="nav-title">Support</label>
              <Link
                to="/tickets-list"
                className={
                  ["/tickets-list", "/create-ticket"].includes(
                    location.pathname
                  ) ||
                    location.pathname.startsWith("/view-ticket-history/") ||
                    location.pathname.startsWith("/reopen-ticket/")
                    ? "ticketsnav active"
                    : "ticketsnav"
                }
              >
                <div className="tickets">
                  {["/tickets-list", "/create-ticket"].includes(
                    location.pathname
                  ) ||
                    location.pathname.startsWith("/view-ticket-history/") ||
                    location.pathname.startsWith("/reopen-ticket/") ? (
                    <IconTicketsActive />
                  ) : (
                    <IconTickets />
                  )}
                  <span>Tickets</span>
                </div>
                {summary?.todaysOpenTickets > 0 && (
                  <div className="newticket">
                    <div className="circle">
                      <small>New</small>
                    </div>
                    <label>{summary.todaysOpenTickets}</label>
                  </div>
                )}

              </Link>

              {authUser?.isAdmin &&
                (authUser?.Agents_Company?.trim() === "Gulf Oil" ||
                  authUser?.Agents_Company?.trim() ===
                  "Global Gulf Support" ||
                  authUser?.Agents_Company?.trim() ===
                  "Global Software") && (
                  <Link
                    to="/escalations-ticket"
                    className={
                      ["/escalations-ticket"].some((path) =>
                        location.pathname.startsWith(path)
                      )
                        ? "active"
                        : ""
                    }
                  >
                    <IconAirplaneTakeoffMenu /> <span>My Tickets</span>
                  </Link>
                )}

              {(authUser?.Agents_Company?.trim() === "Global Assist" ||
                authUser?.Agents_Company?.trim() === "Gulf Oil" ||
                authUser?.Agents_Company?.trim() ===
                "Global Gulf Support") && (
                  <Link
                    to="/customers-list"
                    className={
                      [
                        "/customers-list",
                        "/create-customer",
                        "/edit-customer-details",
                        "/customer-dashboard",
                      ].some((path) => location.pathname.startsWith(path))
                        ? "active"
                        : ""
                    }
                  >
                    <IconCustomers /> <span>Customers</span>
                  </Link>
                )}

              {!!authUser?.isAdmin &&
                authUser?.Agents_Company?.trim() === "Global Assist" && (
                  <Link
                    to="/create-template"
                    className={
                      ["/create-template"].includes(location.pathname)
                        ? "active"
                        : ""
                    }
                  >
                    <IconTemplates /> <span>Templates</span>
                  </Link>
                )}
            </li>

            {(authUser?.Agents_Company?.trim() === "Global Assist" ||
              authUser?.Agents_Company?.trim() === "Gulf Oil" ||
              authUser?.Agents_Company?.trim() === "Global Software" ||
              authUser?.Agents_Company?.trim() ===
              "Global Gulf Support") && (
                <>
                  <li>
                    <label className="nav-title">Reports</label>
                    <Link
                      to="/reports"
                      className={location.pathname === "/reports" ? "active" : ""}
                    >
                      <IconReports /> <span>Reports</span>
                    </Link>
                    <Link
                      to="/call-records"
                      className={location.pathname === "/call-records" ? "active" : ""}
                    >
                      <IconReports /> <span>Call Records</span>
                    </Link>
                    {(authUser?.isAdmin) && (
                      <Link
                        to="/user-logs"
                        className={location.pathname === "/user-logs" ? "active" : ""}
                      >
                        <IconReports /> <span>User Logs</span>
                      </Link>
                    )}
                  </li>
                </>
              )}

            <li className="escalationsmenu">
              <label className="nav-title">Escalations</label>
              <Link
                to="/escalations-report"
                className={
                  ["/escalations-report"].some((path) =>
                    location.pathname.startsWith(path)
                  )
                    ? "active"
                    : ""
                }
              >
                <IconAirplaneTakeoffMenu /> <span>Esc. Report</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* <ul className="bottommenu">
          <li>
            <Link to="#" className={location.pathname === "/" ? "active" : ""}>
              <IconSetting /> <span>Settings</span>
            </Link>

            <Link to="/" onClick={handleLogout}>
              <IconLogout /> <span>Logout</span>
            </Link>
          </li>
        </ul> */}
      </nav>
    </div>
  );
}
